import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { SocketContext } from "../../socket/SocketProvider";
import { FloorMapService } from '../../_services/FloorMapService';
import { useNavigate } from "react-router-dom";
import FloorPlanViewer from './FloorPlanViewer';


export default function SOSAlertDialog() {
  const socket = useContext(SocketContext);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  //const [open, setOpen] = useState(false);
  const [alarmOn, setAlarmOn] = useState(false);
  const [alertData, setAlertData] = useState({});
  const [location, setLocation] = useState({});
  const audioRef = useRef(null);
  const alertMacRef = useRef(null);

  const [permission, setPermission] = useState(true);

  // COUNTDOWN TIMER
  const [timeLeft, setTimeLeft] = useState(30);
  const timerRef = useRef(null);


  const startTimer = () => {
    setTimeLeft(30);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          handleClose(); // Auto close on completion
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  // PLAY SOUND
  const playAlarm = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio("/alert.mp3");
      audioRef.current.loop = true;
      audioRef.current.volume = 1.0;
    }
    audioRef.current.play().catch(() => console.log("Autoplay blocked"));
  };

  // STOP SOUND
  const stopAlarm = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  // USER ALLOW SOUND
  const enableSound = () => {
    localStorage.setItem("sos-sound-permission", "true");
    setPermission(true);
    playAlarm();
    setAlarmOn(true);
  };

  // TOGGLE
  const toggleAlarm = () => {
    if (alarmOn) {
      stopAlarm();
      setAlarmOn(false);
    } else {
      playAlarm();
      setAlarmOn(true);
    }
  };

  const handleClose = () => {
    stopTimer();
    stopAlarm();
    setAlarmOn(false);
    setOpen(false);
    setAlertData({})
    alertMacRef.current = null; // store latest mac
  };
  const LiveLocation = () => {
    stopTimer();
    stopAlarm();
    setAlarmOn(false);
    setOpen(false); navigate("/front/userSensor/floor-map", {
      state: {
        from: "LiveLocation",
        mac: alertData?.mac,
        gatewayMac: alertData?.gatewayMac,
        floorId: location?.floorId,
      },
    });
  };



  // LISTEN SOCKET SOS
  // useEffect(() => {
  //   if (!socket) return;

  //   const topic = "sos-alert";
  //   socket.emit("subscribe", topic);
  //   console.log("Subscribed to:", topic);

  //   const handleSOS = ({ payload, topic }) => {
  //     console.log("topic", topic);
  //     console.log("🚨 SOS RECEIVED:", payload);
  //     console.log("mac:", payload?.mac);

  //     if (
  //       window.location.pathname.startsWith("/device-manager") ||
  //       window.location.pathname.startsWith("/front/userSensor/floor-map")
  //     ) {
  //       return;
  //     }

  //     // if (payload?.mac === alertMacRef.current) {
  //     //   console.log("⛔ Same SOS ignored");
  //     //   return;
  //     // }

  //     alertMacRef.current = payload?.mac; // store latest mac
  //     getFloorList("58:61:63:01:D0:7F")


  //     setAlertData({
  //       mac: payload?.mac,
  //       time: payload?.timestamp,
  //       gatewayMac: payload?.gatewayMac,
  //     });

  //     startTimer(); // start countdown on every alert

  //     // If NO permission → show permission first
  //     if (!localStorage.getItem("sos-sound-permission")) {
  //       setPermission(false);
  //       setOpen(true);
  //       return;
  //     }

  //     // If permission exists → direct alert + alarm
  //     setPermission(true);
  //     setOpen(true);
  //     setAlarmOn(true);
  //     playAlarm();
  //   };

  //   socket.on("sos-alert", handleSOS);

  //   return () => {
  //     stopTimer();
  //     socket.off("sos-alert", handleSOS);
  //     socket.emit("unsubscribe", topic);
  //     console.log("Unsubscribed:", topic);
  //   };
  // }, [socket]);

  // LISTEN MQTT SOS
  useEffect(() => {
    const topic = "sos-alert";

    const subscribeToTopic = () => {
      socket.subscribe(topic, { qos: 1 }, (err) => {
        if (err) {
          console.error("MQTT Subscribe Error:", err);
        } else {
          console.log("Subscribed to:", topic);
        }
      });
    };

    if (socket.connected) {
      subscribeToTopic();
    } else {
      socket.on("connect", subscribeToTopic);
    }

    const handleMessage = async (receivedTopic, message) => {
      if (receivedTopic !== topic) return;

      try {
        const payload = JSON.parse(message.toString());

        console.log("topic", receivedTopic);
        console.log("🚨 SOS RECEIVED:", payload);
        console.log("mac:", payload?.mac);

        if (
          window.location.pathname.startsWith("/device-manager") ||
          window.location.pathname.startsWith("/front/userSensor/floor-map")
        ) {
          return;
        }

        // Ignore duplicate SOS if required
        // if (payload?.mac === alertMacRef.current) {
        //   console.log("⛔ Same SOS ignored");
        //   return;
        // }

        alertMacRef.current = payload?.mac;

        await getFloorList(payload?.gatewayMac);

        setAlertData({
          mac: payload?.mac,
          time: payload?.timestamp,
          gatewayMac: payload?.gatewayMac,
        });

        startTimer();

        // First-time permission popup
        if (!localStorage.getItem("sos-sound-permission")) {
          setPermission(false);
          setOpen(true);
          return;
        }

        // Alarm enabled
        setPermission(true);
        setOpen(true);
        setAlarmOn(true);
        playAlarm();
      } catch (error) {
        console.error("Error processing SOS message:", error);
      }
    };

    socket.on("message", handleMessage);

    return () => {
      stopTimer();

      socket.unsubscribe(topic, (err) => {
        if (err) {
          console.error("Unsubscribe Error:", err);
        } else {
          console.log("Unsubscribed:", topic);
        }
      });

      socket.off("message", handleMessage);
      socket.off("connect", subscribeToTopic);
    };
  }, [socket]);

  const getFloorList = async (gatewayMac) => {
    try {
      gatewayMac = gatewayMac.replace(/:/g, '');
      let res = await FloorMapService.getSingleFloor(gatewayMac);
      if (res.status === true) {
        setLocation(res.data)
      } else {

      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFloorList("58:61:63:01:D0:7F")
    return () => stopTimer();
  }, []);


  // FIX AUTOPLAY CHROME BLOCK (click unlock)
  // useEffect(() => {
  //   const unlockAudio = () => {
  //     if (!audioRef.current) {
  //       audioRef.current = new Audio("/alert.mp3");
  //       audioRef.current.loop = true;
  //     }
  //     audioRef.current.play().catch(() => { });
  //     document.removeEventListener("click", unlockAudio);
  //   };
  //   document.addEventListener("click", unlockAudio);
  // }, []);

  return (
    <>
      {/* FIRST TIME PERMISSION POPUP */}
      {open && !permission && (
        <Dialog
          open={true}
          maxWidth="xs"
          PaperProps={{
            sx: {
              borderRadius: 3,
              p: 2,
              textAlign: "center",
              background: "linear-gradient(#fffce6, #fffff7)",
              border: "3px solid #ffd54f"
            }
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 800,
              color: "#b38f00",
              fontSize: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1
            }}
          >
            🔔 Enable Emergency Alert Sound
          </DialogTitle>

          <DialogContent>
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 500,
                color: "#6d5e00",
                lineHeight: 1.6
              }}
            >
              To ensure you don’t miss a critical SOS alert,
              please allow sound access.
              <br />
              <strong>This alarm only triggers for emergencies</strong> such as:
            </Typography>

            <Box sx={{ mt: 2, textAlign: "left", color: "#6b5d00", pl: 4 }}>
              <ul style={{ lineHeight: 1.7, margin: 0, padding: 0 }}>
                <li>🚨 SOS panic device activation</li>
                <li>⚠ Life-threat or danger signals</li>
                <li>📍 Critical GPS emergency events</li>
              </ul>
            </Box>

            <Typography
              sx={{
                mt: 2,
                fontSize: "14px",
                color: "#867300",
                fontStyle: "italic"
              }}
            >
              Sound will remain off until manually authorized.
            </Typography>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              color="warning"
              sx={{
                fontWeight: 700,
                borderRadius: 2,
                px: 4
              }}
              onClick={enableSound}
            >
              Allow Sound Access
            </Button>
          </DialogActions>

          <Typography
            sx={{
              textAlign: "center",
              fontSize: "12px",
              color: "#9e7f00",
              pb: 2
            }}
          >
            You can disable alerts anytime from settings.
          </Typography>
        </Dialog>
      )}

      {/* SOS ACTIVE ALERT POPUP */}
      {open && permission && (
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: 3,
              border: "3px solid #ffcc00",
              background: "linear-gradient(#fffce6, #fffff5)",
              paddingBottom: 1
            }
          }}
        >
          <DialogTitle
            sx={{
              textAlign: "center",
              color: "#b38f00",
              fontWeight: 800,
              fontSize: "22px",
              display: "flex",
              justifyContent: "center",
              gap: 1,
              alignItems: "center"
            }}
          >
            <WarningAmberIcon fontSize="large" /> ⚠ SOS ALERT (CAUTION)
          </DialogTitle>

          <DialogContent sx={{ textAlign: "center", mt: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#b38f00" }}>
              SOS Triggered From Device: {alertData.mac}
            </Typography>

            <Typography sx={{ mt: 2, fontWeight: "bold", color: "#cc9900" }}>
              Immediate Attention Required!
            </Typography>

            <Typography
              sx={{
                mt: 1,
                fontSize: "14px",
                color: "#444",
                lineHeight: 1.5,
                fontWeight: 500
              }}
            >
              The device has triggered an emergency SOS signal.
              <br />Please respond & take quick action.
            </Typography>

            <Box
              sx={{
                mt: 3,
                borderRadius: 2,
                overflow: "hidden",
                border: "2px solid #e6c200"
              }}
            >
              <FloorPlanViewer floorDetails={location} />
              {/* <iframe
                width="100%"
                height="250"
                style={{ border: "0" }}
                src={`https://maps.google.com/maps?q=23.0441823,72.5126973&z=15&output=embed`}
                title="live-location"
              /> */}
            </Box>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 480,
                  px: 3,
                  py: 1.6,
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",  // ⭐ spread horizontally
                  gap: 1.5,
                  bgcolor: "rgba(255, 243, 224, 0.98)",
                  border: "1px solid #ff9800",
                  boxShadow: "0 0 0 3px rgba(255, 193, 7, 0.35)",
                  position: "relative",
                  overflow: "hidden",

                  "::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(120deg, rgba(255,193,7,0.35), rgba(255,87,34,0.25))",
                    opacity: 0.35,
                    zIndex: -1,
                  },

                  animation: "pulseTimer 1.4s ease-in-out infinite",
                  "@keyframes pulseTimer": {
                    "0%": { boxShadow: "0 0 0 0 rgba(255, 87, 34, 0.6)" },
                    "70%": { boxShadow: "0 0 0 10px rgba(255, 87, 34, 0)" },
                    "100%": { boxShadow: "0 0 0 0 rgba(255, 87, 34, 0)" },
                  },
                }}
              >
                {/* ICON + TEXT IN ONE LINE */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <WarningAmberIcon sx={{ fontSize: 24, color: "#e65100" }} />
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: "#bf360c",
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    Auto closing in
                  </Typography>
                </Box>

                {/* COUNTDOWN IN SAME LINE */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 24,
                      fontWeight: 800,
                      color: "#d32f2f",
                    }}
                  >
                    {timeLeft}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#5d4037",
                    }}
                  >
                    sec
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Typography
              sx={{ mt: 2, fontSize: "13px", color: "#777", fontStyle: "italic" }}
            >
              *Location is approximate based on last known GPS/Network ping*
            </Typography>
          </DialogContent>

          <DialogActions
            sx={{
              justifyContent: "space-between",
              px: 3,
              pb: 2,
              pt: 1
            }}
          >
            {/* 🔊 TOGGLE BUTTON */}
            <Button
              variant={alarmOn ? "contained" : "outlined"}   // style change
              color={alarmOn ? "error" : "success"}           // red when ON, green when OFF
              startIcon={alarmOn ? <VolumeOffIcon /> : <VolumeUpIcon />}
              sx={{ fontWeight: 700 }}
              onClick={toggleAlarm}
            >
              {alarmOn ? "Alarm Off" : "Alarm On"}
            </Button>
            <Button
              variant="contained"
              color="warning"
              sx={{ fontWeight: 700 }}
              onClick={LiveLocation}
            >
              Take Live
            </Button>
            {/* ❌ CLOSE BUTTON */}
            <Button
              variant="outlined"
              color="error"
              startIcon={<CloseRoundedIcon />}
              sx={{ fontWeight: 700 }}
              onClick={handleClose}
            >
              Close Alert
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
